import { reactErrorHandler } from './instrument' // OpenObserve RUM must init first
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/bamboo.css'
import App from './App.jsx'
import { setLoaderMilestone } from './utils/initialLoaderManager'
import { isNetworkError } from './utils/networkUtils'

// Global handler for unhandled promise rejections
// This prevents crashes from network errors during wake-from-sleep
// while still logging them for debugging
window.addEventListener('unhandledrejection', (event) => {
  if (isNetworkError(event.reason)) {
    // Always log the error for debugging
    console.warn('[Global] Network error caught - this is expected during wake from sleep:', event.reason?.message || event.reason)

    // In development, show error but still prevent crash
    // In production, silently suppress to avoid user-facing crashes
    if (import.meta.env.DEV) {
      console.error('[Global] DEV MODE: Network error details (not prevented in dev for debugging):', event.reason)
    }

    // Prevent crash in all environments
    event.preventDefault()
  }
  // Non-network errors will propagate normally and show in console
})

// Global handler for uncaught errors (sync errors)
window.addEventListener('error', (event) => {
  if (event.message && isNetworkError(event.message)) {
    console.warn('[Global] Network error caught:', event.message)

    if (import.meta.env.DEV) {
      console.error('[Global] DEV MODE: Sync network error details:', event.message)
    }

    event.preventDefault()
    return true
  }
})

// Note: Public route detection and initial loader hiding is handled in index.html
// inline script for faster execution. ProtectedRoute will handle hiding the loader
// for protected routes once workspace data is ready.

// Signal that React is mounting
setLoaderMilestone('REACT_MOUNTED')

createRoot(document.getElementById('root'), {
  // React 19 error handler integration with OpenObserve RUM
  onUncaughtError: reactErrorHandler,
  onCaughtError: reactErrorHandler,
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
